


export type AbacusAuthorisationRoles = 'Default' | 'Hr';

export const AbacusAuthorisationRoles = {
    Default: 'Default' as AbacusAuthorisationRoles,
    Hr: 'Hr' as AbacusAuthorisationRoles
};

